// extracted by mini-css-extract-plugin
export default {"page":"AdminTablePageLayout_page__nLTnr","pageWrapper":"AdminTablePageLayout_pageWrapper__W3PaL"};